var _ = require('underscore');
var moment = require('moment-timezone');

/**
 * Takes a date as a string or number and reformats it
 *
 * @param {string|number} dateString Example: "2000-01-01 12:34" or 1495055734
 * @param {string} dateFormat Example: "MMMM DD YYYY, h:mm a"
 * @returns {string} Formatted Date
 *
 * @requires moment
 * @see {@link https://momentjs.com/}
 */
var formatDate = function(dateString, dateFormat) {
    dateFormat = dateFormat || "MMMM DD YYYY, h:mm a";
    return dateString ? moment.utc(dateString).local().format(dateFormat) : "";
};

/**
 * Displays dates in different formats depending on certain conditions
 * @param {string|number} startDate Example: "2000-01-01 12:34" or 1495055734
 * @param {string|number} endDate Example: "2000-01-01 12:34" or 1495055734
 * @param {string} dateTimeFormat
 * @param {string} timeFormat
 * @param {string} timezone Example: "America/Los_Angeles"
 *
 * @requires moment
 * @requires moment-timezone
 * @see {@link https://momentjs.com/}
 */
var formatEventDates = function(startDate, endDate, dateTimeFormat, timeFormat, timezone) {
    dateTimeFormat = dateTimeFormat || "MMMM DD YYYY, h:mm a";
    timeFormat = timeFormat || "h:mm a";

    var dateTimeNoPeriodFormat = dateTimeFormat.replace(/[aA]/, '').trim();
    var startFormat = dateTimeFormat,
        endFormat = dateTimeFormat;

    var mStartDate = moment.utc(startDate);
    if (timezone) {
        mStartDate = mStartDate.tz(timezone);
    } else {
        mStartDate = mStartDate.local();
    }

    if(endDate) {
        var mEndDate = moment.utc(endDate);
        if (timezone) {
            mEndDate = mEndDate.tz(timezone);
        } else {
            mEndDate = mEndDate.local();
        }
        var dayMatch = mStartDate.isSame(mEndDate, "day");
        var meridiemMatch = mStartDate.format("a") === mEndDate.format("a");
        if(!meridiemMatch && dayMatch) {
            endFormat = timeFormat;
        } else if(meridiemMatch && dayMatch) {
            startFormat = dateTimeNoPeriodFormat;
            endFormat = timeFormat;
        }
    }
    if (endDate) {
        return mStartDate.format(startFormat) + " - " + mEndDate.format(endFormat);
    } else {
        return mStartDate.format(startFormat);
    }
};

/**
 * Iterates through office_hours and reformats each day's open/close time
 * @param {object} office_hours
 * @returns {object} A reformatted version of office_hours
 *
 * @requires underscore
 * @requires moment
 */
var formatOfficeHours = function(parentObject, office_hours) {
    var formatted_office_hours = {};
    formatted_office_hours.note = parentObject[office_hours].note;
    formatted_office_hours.setting = parentObject[office_hours].setting;

    var formattedHours = [];
    var dayToDay = {
        "mon": "Monday",
        "tue": "Tuesday",
        "wed": "Wednesday",
        "thu": "Thursday",
        "fri": "Friday",
        "sat": "Saturday",
        "sun": "Sunday"
    };

    _.each(dayToDay, function(day, key) {
        // get data for the office hours, based on specific key
        var dayData = parentObject[office_hours].days[key];

        _.each(dayData, function(hour) {
            // format date via momentjs
            var open = moment(hour.open, 'HH:mm').format('h:mm A');
            var closed = moment(hour.close, 'HH:mm').format('h:mm A');
            // insert proper string into array
            formattedHours.push([dayToDay[key] + " " + (open + " - " + closed)]);
        });
    });

    formatted_office_hours.days = formattedHours;

    if (parentObject[office_hours]) {
        parentObject['formatted_' + office_hours] = formatted_office_hours;
    }
};

exports.formatOfficeHours = formatOfficeHours;
exports.formatDate = formatDate;
exports.formatEventDates = formatEventDates;



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Lib1ThemeBuild/Platforms/1804Build/~/poly-js-utils/src/datetime-helpers.js
// module id = 191
// module chunks = 8